import React from "react";
import { Pitcher } from "../repository/challengeRepository";
import { SampleResult } from "./runner";

interface ExamplePitchersProps {
  pitchers: Pitcher[];
  results: Map<string, SampleResult> | null; // null until the learner runs their code
  functionName: string;
}

const PREVIEW_LENGTH = 16;

const ExamplePitchers: React.FC<ExamplePitchersProps> = ({ pitchers, results, functionName }) => {
  if (pitchers.length === 0) return null;

  return (
    <div className="examples">
      <h3>Try it on real pitchers</h3>
      <p className="muted small">
        A few 2025 seasons, so you can see what <code>{functionName}</code> gets as input — and what
        it returns. {results ? "" : "Press Run to see your function's output for each."}
      </p>
      {pitchers.map((p) => {
        const result = results?.get(p.pitcher_id);
        return (
          <div key={p.pitcher_id} className="example-row">
            <div className="example-info">
              <span className="example-name">{p.name}</span>
              <span className="example-pitches">
                <code>
                  "{p.pitches.slice(0, PREVIEW_LENGTH)}
                  {p.pitches.length > PREVIEW_LENGTH ? "…" : ""}"
                </code>{" "}
                ({p.pitches.length.toLocaleString()} pitches)
              </span>
            </div>
            {results &&
              (result ? (
                <span className={result.truthy ? "example-result truthy" : "example-result falsy"}>
                  → {result.display}
                </span>
              ) : (
                <span className="example-result muted">—</span>
              ))}
          </div>
        );
      })}
    </div>
  );
};

export default ExamplePitchers;
